// extracted by mini-css-extract-plugin
export default {"container":"CopyableTextField_container__GLQs0","text":"CopyableTextField_text__oGlR-","copyBtn":"CopyableTextField_copyBtn__12wjb","info":"CopyableTextField_info__bs35u"};